declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

export type GTMEvent = {
  event: string;
  [key: string]: any;
};

export const sendGTMEvent = (event: GTMEvent): void => {
  if (typeof window === 'undefined') return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(event)
}
